import gql from 'graphql-tag';
import { ESTIMATE_BASE_FRAGMENT } from '../fragments/common';
import { RECURRING_SCHEDULE_FRAGMENT } from '../fragments/recurringSchedule';
import { NOTE_FRAGMENT } from '../fragments/notes';
import { ATTACHMENT_FRAGMENT } from '../fragments/attachments';
import { MESSAGE_FRAGMENT } from '../fragments/messages';
import { CLIENT_FRAGMENT } from '../fragments/client';
import { PROPERTY_FRAGMENT } from '../fragments/property';
import { CREW_FRAGMENT } from '../fragments/crew';
import { SERVICE_ITEM_FRAGMENT } from '../fragments/serviceItems';
import { ALTERNATE_BILLING_FRAGMENT } from '../fragments/billing';

// Re-export shared fragments for convenience
export {
  ESTIMATE_BASE_FRAGMENT as BASE_FRAGMENT,
  RECURRING_SCHEDULE_FRAGMENT,
  NOTE_FRAGMENT,
  ATTACHMENT_FRAGMENT,
  MESSAGE_FRAGMENT,
  CLIENT_FRAGMENT,
  PROPERTY_FRAGMENT,
  CREW_FRAGMENT,
  SERVICE_ITEM_FRAGMENT,
  ALTERNATE_BILLING_FRAGMENT,
};

export const FULL_FRAGMENT = gql`
  fragment EstimateFullFragment on Estimate {
    ...EstimateBaseFragment
    chat_id
    recurringSchedule {
      ...RecurringScheduleFragment
    }
    notes {
      ...NoteFragment
    }
    attachments {
      ...AttachmentFragment
    }
    messages {
      ...MessageFragment
    }
    client {
      ...ClientFragment
    }
    property {
      ...PropertyFragment
    }
    crew {
      ...CrewFragment
    }
    serviceItems {
      ...ServiceItemFragment
    }
    alternateBillingInfo {
      ...AlternateBillingFragment
    }
  }
  ${ESTIMATE_BASE_FRAGMENT}
  ${RECURRING_SCHEDULE_FRAGMENT}
  ${NOTE_FRAGMENT}
  ${ATTACHMENT_FRAGMENT}
  ${MESSAGE_FRAGMENT}
  ${CLIENT_FRAGMENT}
  ${PROPERTY_FRAGMENT}
  ${CREW_FRAGMENT}
  ${SERVICE_ITEM_FRAGMENT}
  ${ALTERNATE_BILLING_FRAGMENT}
`;
